// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__NIHCD","label":"Category_label__ZNZ7-","content":"Category_content__q-Adp","header":"Category_header__2ulM3","location":"Category_location__1Ryv9"};